'use strict';

var _base = require('base-64');
var _base2 = _interopRequireDefault(_base);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
if (typeof global !== 'undefined') {
  if (!global.btoa || !global.atob) {
    global.btoa = _base2.default.encode;
    global.atob = _base2.default.decode;
  }
}